import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Role {
  roleId: number;
  roleName: string;
  version: number;
  isActive: string;
}

interface UserParticipantXref {
  userParticipantXrefId: number;
  userId: number;
  participantId: number;
  version: number;
}


interface AuthState {
  isLogin: boolean;
  userName: string;
  firstName: string;
  lastName: string;
  id: number;
  emailId: string;
  language: string;
  menuPosition: string;
  theme: string;
  jwtToken: string;
  imagePath: string;
  tenantId: string;
  refreshToken: string;
  authorityValue: string;
  expiresIn: string;
  userParticipantXref: UserParticipantXref[];
  roles: Role | null;
  aadReferenceId: string;
  clientId: number;
  defaultParticipantId: any;
  version: number
  participantArray: any[]
  clientVo: any;
  expiresOn: string;
  homeAccountId : string;
  messageRes: string;
}

const initialState: AuthState = {
  isLogin: false,
  userName: '',
  firstName: '',
  lastName: '',
  id: 0,
  emailId: '',
  language: '',
  menuPosition: 'Top',
  theme: '',
  jwtToken: '',
  imagePath: '',
  tenantId: '',
  refreshToken: '',
  authorityValue: '',
  expiresIn: '',
  userParticipantXref: [],
  roles: null,
  aadReferenceId: '',
  clientId: 0,
  defaultParticipantId: 0,
  version: 0,
  participantArray: [],
  clientVo: null,
  expiresOn:"",
  homeAccountId:"",
  messageRes:""

};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // Action to store login details
    setLoginDetails: (state, action: PayloadAction<Partial<AuthState>>) => {
      return { ...state, ...action.payload };
    },
    // Action to reset auth details (used only when logging out)
    resetAuthDetails: () => initialState,
    // Action to set error message, if needed
    setAuthError: (state, action: PayloadAction<string>) => {
      // Optionally, you can handle error state here
    },
  },
});

export const { setLoginDetails, resetAuthDetails, setAuthError } = authSlice.actions;
export default authSlice.reducer;
